import { BOOK_TITLES } from "../constants";

const imagesContext = require.context(
  "../assets/images/processed-books",
  true,
  /\.(jpg|jpeg|png)$/,
);

function loadProcessedBooks() {
  const booksMap = {};

  imagesContext.keys().forEach((key) => {
    const folder = key.split("/")[1];
    const src = imagesContext(key);

    if (!booksMap[folder]) {
      booksMap[folder] = {
        id: folder,
        title: BOOK_TITLES[folder] || folder,
        images: [],
      };
    }

    booksMap[folder].images.push(src);
  });

  return Object.values(booksMap);
}

export const PROCESSED_BOOKS = loadProcessedBooks();

export const PROCESSED_BOOK_IMAGES = PROCESSED_BOOKS.flatMap((book) =>
  book.images.map((src) => ({
    src,
    alt: book.title,
    bookId: book.id,
    bookTitle: book.title,
  })),
);
